module.exports = __webpack_public_path__ + "static/img/dzimg.e3d13f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/dzimg.png
// module id = THAN
// module chunks = 1